import { X } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from 'src/app/_services/candidate.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-candidate-tags',
    templateUrl: './candidate-tags.component.html',
    styleUrls: ['./candidate-tags.component.scss'],
    standalone: false
})
export class CandidateTagsComponent implements OnInit {
  tagText: string = ''
  tagArray: any =[]
  @Input() candidatetoAdd;
  @Input() bulkcandidates
  tagList: any
  tagid: number
  payloadtagarray: any = []
  tags: any
  tagchips: any = []
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  tagerror: string
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  tagmessage: string = '';
  tagErrorMessage: string = '';
  updatedTags: any = [];
  addTagSpinner: boolean = false;

  constructor(private candidateservice: CandidateService, private modalService: NgbModal) { }

  ngOnInit() {
    this.gettags();
  }

  createTag(tagdata) {
    this.tagErrorMessage = '';
    if(this.tagText != null && this.tagText != '') {
      if (GlobalService.hasHTMLTags(this.tagText)) {
        this.tagErrorMessage = 'HTML tags are not allowed.';
        this.tags = [];
        return;
      }
      let payload = {
        tagtext: this.tagText.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x=>x.tagtext.toLowerCase().trim() == this.tagText.toLowerCase().trim())
      if(newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x=>x.tagid == newtagtext[0].tagid)
        if(tagid.length > 0) {
          this.tagText = ''
          this.autocomplete.closePanel()
        } else {
        this.tagArray.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
          this.tagchips.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
          this.updatedTags.push({action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber});
          this.tagText = ''
          this.autocomplete.closePanel()
        }
      } else {
        this.candidateservice.createupdatetags(payload).subscribe((res:any)=>{
          if(res.status == "success") {
            this.tagid = res.tagid
            if(this.bulkcandidates.length > 0) {
              for (let candidate of this.bulkcandidates) {
                this.tagArray.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate})
                this.tagchips.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate})
                this.updatedTags.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate});
                this.tagchips = _.uniq(this.tagchips, 'tagid')
              }
            } else {
              this.tagArray.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
              this.tagchips.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
              this.updatedTags.push({action: 'create', tagtext: this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber});

            }

            this.tagText = ''
          }
        })
      }


    }
  }

  doneFunction() {
    if((this.tagText == null || this.tagText == '' || this.tagText.trim() == '') && !this.updatedTags.length) {
      this.tagErrorMessage = 'Tag cannot be empty. Please provide a valid tag.';
      return;
    }

    if (GlobalService.hasHTMLTags(this.tagText)) {
      this.tagErrorMessage = 'HTML tags are not allowed.';
      this.tags = [];
      return;
    }

    let payloadtagarray = [];
    this.tagmessage = '';
    if(this.tagText != null && this.tagText != '') {
      let payload = {
        tagtext: this.tagText.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x=>x.tagtext.toLowerCase().trim() == this.tagText.toLowerCase().trim())
      if(newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x=>x.tagid == newtagtext[0].tagid)
        if(tagid.length > 0) {
          this.tagText = ''
          this.autocomplete.closePanel()
        } else {
        this.tagArray.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
          this.tagchips.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
          this.updatedTags.push({action: 'create', tagtext:newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidatetoAdd.candidatenumber});
          this.tagText = ''
          this.autocomplete.closePanel()
      }
     } else {
      this.addTagSpinner = true;
      this.candidateservice.createupdatetags(payload).subscribe((res:any)=>{
        if(res.status == "success") {
          this.tagid = res.tagid
          if(this.bulkcandidates.length > 0) {
            for (let candidate of this.bulkcandidates) {
              this.tagArray.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate})
              this.tagchips.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate})
              this.updatedTags.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: candidate});
              this.tagchips = _.uniq(this.tagchips, 'tagid')
            }
          } else {
            this.tagArray.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
            this.tagchips.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
            this.updatedTags.push({action: 'create', tagtext:this.tagText, tagid: this.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})


          }

          this.tagText = ''
        } else {
          this.addTagSpinner = false;
          this.tagmessage = res.message;
        }
      }, (error) => {this.addTagSpinner=false}, () => {
        this.addTagSpinner = false;
      })

    }
   } else {
      if(this.updatedTags.length) {
        const payload = {
          tags: this.updatedTags.map(x => (_.omit(x, 'tagtext')))
        }
        this.addTagSpinner = true;
        this.candidateservice.updatetags(payload).subscribe((res:any)=>{
          if(res.status == "success") {
            this.modalService.dismissAll()
            this.passEntry.emit('updatetags');
          } else {
            this.modalService.dismissAll()
            this.passEntry.emit('error');
          }
          this.addTagSpinner = false;
        })

      }
    }

  }

  dismiss() {
    this.modalService.dismissAll()
  }

  gettags() {
    this.updatedTags = [];
    this.candidateservice.gettags(this.candidatetoAdd.candidatenumber).subscribe((res:any)=>{
      this.tagList = res.candidatetags
      this.tagList.map(x=>{
        if(this.bulkcandidates.length > 0) {
          for (let candidate of this.bulkcandidates) {
            this.tagArray.push({action: 'update', tagtext:x.tagtext, tagid: x.tagid, candidatenumber: candidate})
            this.tagchips.push({action: 'update', tagtext:x.tagtext, tagid: x.tagid, candidatenumber: candidate})
            this.tagchips = _.uniq(this.tagchips, 'tagid')

          }
        } else {
          this.tagArray.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidatetoAdd.candidatenumber})
          this.tagchips.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidatetoAdd.candidatenumber})

        }
        })
    })
  }

  searchTags(event) {
    this.tagErrorMessage = '';
    if (GlobalService.hasHTMLTags(event)) {
      this.tagErrorMessage = 'HTML tags are not allowed.';
      this.tags = [];
      return;
    }

    let data = event.replace(/'/g, "''");
      this.candidateservice.gettypedtags(data).subscribe((res:any)=>{
        this.tags = res.message;
      })
  }

  unselect(tagid) {
    this.tagErrorMessage = '';
    this.tagArray = _.reject(this.tagArray, {tagid: tagid})
    this.tagchips = _.reject(this.tagchips, {tagid: tagid})
    this.updatedTags.push({action: 'archive', tagid: tagid, candidatenumber: this.candidatetoAdd.candidatenumber});
    this.payloadtagarray.push({action:'archive', tagid: tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
  }

  addTag(data) {
    this.tagErrorMessage = '';
    if(this.bulkcandidates.length > 0) {
      for (let candidate of this.bulkcandidates) {
        this.tagArray.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: candidate})
        this.tagchips.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: candidate})
        this.updatedTags.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: candidate});
        this.tagchips = _.uniq(this.tagchips, 'tagid')
      }
    } else {
      const tagid = this.tagArray.filter(x=>x.tagid == data.tagid)[0]
      if(!tagid) {
        this.tagArray.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
        this.tagchips.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: this.candidatetoAdd.candidatenumber})
        this.updatedTags.push({action: 'create', tagtext:data.tagtext, tagid: data.tagid, candidatenumber: this.candidatetoAdd.candidatenumber});
      }
    }
  }

}
